exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".page-break{page-break-before:always;page-break-inside:avoid}h2{font-size:26px!important}.text-title{font-weight:700;font-size:13.5px!important}.text-description,p{font-size:12.5px!important}.text-description{font-style:italic;text-align:justify;margin-top:1rem}td,th{font-size:12.5px!important}tfoot td,th{font-weight:700}tfoot td{font-size:13.5px!important}tfoot tr td:first-child{padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/main/webapp/app/entities/stat/stat-graph/stat-graph.component.scss
// module id = 447
// module chunks = 0